import React from "react";
import styled from "styled-components";
import arrowTopRight from "../assets/arrow-top-right.png";
import COLORS from "../colors";

function DesktopProjectBlock({ selectedProject, getProjectInfo }) {
  if (selectedProject) {
    const info = getProjectInfo(selectedProject);
    if (info.type === "Writing") {
      return (
        <StyledProjectTextBlock>
          <ProjectWrapper>
            <WritingTitle>{info.title}</WritingTitle>
            <ProjectTitleRow>
              <ProjectTitle>{info.source && `${info.source}`}</ProjectTitle>
              <ProjectLink
                href={info.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ArrowIcon src={arrowTopRight} alt="Open in new tab" />
              </ProjectLink>
            </ProjectTitleRow>
          </ProjectWrapper>
        </StyledProjectTextBlock>
      );
    }
    return (
      <StyledProjectTextBlock>
        <ProjectWrapper>
          <ProjectTitleRow>
            <ProjectTitle>{info.title}</ProjectTitle>
            <ProjectLink
              href={info.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ArrowIcon src={arrowTopRight} alt="Open in new tab" />
            </ProjectLink>
          </ProjectTitleRow>
          <ProjectSubtitle>
            {info.role && `${info.role} | `}
            {info.source && `${info.source}`}
            {info.year && ` | ${info.year}`}
          </ProjectSubtitle>
          <ProjectDescription>{info.description}</ProjectDescription>
        </ProjectWrapper>
      </StyledProjectTextBlock>
    );
  }
  return;
}

export default DesktopProjectBlock;

export const StyledProjectTextBlock = styled.div`
  width: 500px;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: none;
`;

const ProjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const ProjectTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

const ProjectTitle = styled.div`
  font-size: 25px;
  font-weight: 400;
  font-family: forma-djr-deck, sans-serif;
`;

const ProjectSubtitle = styled.div`
  font-family: forma-djr-deck, sans-serif;
  font-weight: 400;
  letter-spacing: 0.025em;
  font-size: 18px;
  line-height: 22px;
  color: ${COLORS.darkGray};
`;

const ProjectDescription = styled.div`
  font-family: forma-djr-deck, sans-serif;
  font-weight: 400;
  letter-spacing: 0.02em;
  font-size: 18px;
  line-height: 25px;
`;

const ProjectLink = styled.a`
  color: inherit;
  text-decoration: none;
  font-size: 22px;
  font-weight: 400;
  font-family: forma-djr-deck, sans-serif;
  &:hover {
    text-decoration: underline;
  }
`;

const ArrowIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 6px;
  vertical-align: middle;
`;

const WritingTitle = styled.div`
  font-weight: 300;
  margin-bottom: 100px;
  font-style: italic;
  font-size: 60px;
  line-height: 72px;
`;
